import { api } from "@/api"
import type { User } from "@/composables/useCurrentUser"

export const retrieveSelfUser = async () => {
  const { body } = await api.get<User>("/users/self/")
  return body
}
